import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import CallService from '../../services/call.service';
import CallStartService from '../../services/call-start.service';
import Config from '../../utils/config.service';
import Toast from '../../services/toast.service';
import Session from '../../utils/session.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'modal-call-incoming',
	templateUrl: './modal-call-incoming.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalCallIncomingComponent implements OnInit, OnDestroy {
	private callService: CallService = inject(CallService);
	private callStartService: CallStartService = inject(CallStartService);
	private config: Config = inject(Config);
	private toast: Toast = inject(Toast);
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalCallIncomingComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		var sessionUser = this.session.getSession();
		this.vm.origin = (sessionUser && sessionUser.user && sessionUser.user.origin) ? sessionUser.user.origin : 'minudoc.ee';
		this.vm.defaultProfilePicture = this.vm.origin == 'siffi.com'
			? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_siffi_green.png'
			: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture.png';
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onCallEnded',
				(event, res) => { this.handleOnCallEnded(event, res); })
		);
		
		this.vm.close = this.close;
		this.vm.answer = this.answer;
		this.vm.decline = this.decline;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	handleOnCallEnded(event, res) {
		this.callService.stopRinging();
		if (res && res.code && res.code !== 'ACCEPTED') {
			var toastMessageStart = this.angularFilterHelperService.translate('Toast.Call.Missed_Call_From');
			this.toast.show(toastMessageStart + ' ' + this.vm.user.firstName + ' ' + this.vm.user.lastName + '.');
		}
		this.close();
	}
	
	answer() {
		this.callService.stopRinging();
		this.callStartService.answerCall(this.vm.user.userId);
		this.close();
	}
	
	decline() {
		this.callService.stopRinging();
		this.callService.declineCall(this.config.getCallConfig().HANGUP_DETAIL.NORMAL_CLEARING,
			() => {

			},
			() => {

			}
		);
		this.close();
	}
	
	close() {
		this.dialogRef.close();
	}
	
}